import React, { ReactElement, useContext, useEffect, useState } from 'react';
import soyRappiLogo from '../../../assets/soy-rappi-logo.png';
import defaultStyle from './index.module.scss';
import { OtpInput } from 'reactjs-otp-input';
import Back from '../../../assets/arrow-back-black.svg';
import { perfilSatContext } from '../../../context/perfil.sat.context';
import SuccessTooltip from '../success-tooltip';
import loadingSpinner from '../../../assets/loading-spinner.svg';
import ErrorTooltip from '../error-tooltip';

interface Props {
  goBack: () => void;
  inputLogin: string;
  setInputLogin: (x: string) => void;
}

const OtpComponent = ({ goBack, inputLogin, setInputLogin }: Props): ReactElement => {

  const { otp, setOtp, OtpValidation, maskedPhone, Login, errorMessagesOtp } =
    useContext(perfilSatContext);
  const [description, setDescription] = useState<string>('');
  const [closeTooltip, setCloseTooltip] = useState<boolean>(false);
  const [seconds, setSeconds] = useState(60);
  const [showResend, setShowResend] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [closeErrorTooltip, setCloseErrorTooltip] = useState<boolean>(false);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneNumberRegex = /^\d{2,10}$/;

  const descriptionValidation = () => {
    if (phoneNumberRegex.test(inputLogin) && inputLogin.length === 10) {
      setDescription('A tu número de Whatsapp');
    } else if (emailRegex.test(inputLogin)) {
      setDescription(`A tu número ${maskedPhone} asociado al correo`);
    } else {
      setDescription('');
    }
  };

  useEffect(() => {
    descriptionValidation();
  }, [inputLogin]);

  const phoneNumber =
    (phoneNumberRegex.test(inputLogin) ? '+52' : '') + inputLogin;

  useEffect(() => {
    if (seconds === 0) {
      setShowResend(true);
      return;
    }

    const interval = setInterval(() => {
      setSeconds((prevSeconds) => prevSeconds - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [seconds]);

  useEffect(() => {
    if (otp.length === 6) {
      OtpValidation(inputLogin, otp);
      setShowSpinner(true);
    }
  }, [otp]);

  const resentCode = () => {
    Login(inputLogin);
    setCloseTooltip(false);
    setShowResend(false);
    setSeconds(60);
  };

  useEffect(() => {
    if (errorMessagesOtp) {
      setShowSpinner(false);
      setInputLogin('');
      setShowResend(false);
      setSeconds(60);
    }
  }, [errorMessagesOtp]);

  return (
    <div className={defaultStyle.container}>
      <div className={defaultStyle.headerContainer}>
        <div className={defaultStyle.backContainer} onClick={goBack}>
          <img
            src={Back}
            alt={'Back'}
            style={{
              cursor: 'pointer',
              marginLeft: '10px',
              marginRight: '5px'
            }}
          />
          <div className={defaultStyle.backText}>Volver</div>
        </div>
        <img
          src={soyRappiLogo}
          alt={'soyRappiLogo'}
          className={defaultStyle.logoPosition}
        />
      </div>
      <div className={defaultStyle.border}></div>
      {errorMessagesOtp && !closeErrorTooltip && (
        <ErrorTooltip
          errorMessages={errorMessagesOtp}
          setCloseTooltip={setCloseErrorTooltip}
        />
      )}
      {inputLogin && !closeTooltip && (
        <SuccessTooltip
          successMessage={phoneNumber}
          setCloseTooltip={setCloseTooltip}
        />
      )}
      <div className={defaultStyle.titleOtp}>
        Ingresa el código que enviamos 👀
      </div>
      <div className={defaultStyle.description}>
        <>
          {description} &nbsp;
          <div className={defaultStyle.emailColor}>{phoneNumber}</div>
        </>
      </div>
      <OtpInput
        numInputs={6}
        onChange={setOtp}
        separator={<span>&nbsp;&nbsp;</span>}
        isInputNum={true}
        value={otp}
        containerStyle={defaultStyle.otpContainer}
        inputStyle={defaultStyle.otpInput}
        placeholder={'000000'}
      />
      {showSpinner ? (
        <img
          src={loadingSpinner}
          alt={'loadingSpinner'}
          className={defaultStyle.spinner}
        />
      ) : (
        <div className={defaultStyle.otpNewCode}>
          {showResend ? (
            <div className={defaultStyle.resendCodeContainer}>
              ¿No lo recibiste aún? &nbsp;
              <div
                onClick={resentCode}
                className={defaultStyle.emailColor}
                style={{ fontWeight: 'bold', cursor: 'pointer' }}
              >
                Reenviar código
              </div>
            </div>
          ) : (
            <div>Solicita un nuevo código en {seconds} segundos</div>
          )}
        </div>
      )}
    </div>
  );
};

export default OtpComponent;
